import { render } from "./LessonsGrid.vue?vue&type=template&id=64adcebb&scoped=true"
import script from "./LessonsGrid.vue?vue&type=script&lang=js"
export * from "./LessonsGrid.vue?vue&type=script&lang=js"

import "./LessonsGrid.vue?vue&type=style&index=0&id=64adcebb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64adcebb"]])

export default __exports__